import type { HTMLAttributes } from "react";

import { cn } from "@/utils/lib";

function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-card", className)}
      {...props}
    />
  );
}

export { Skeleton };
